const stripeConfig = {
  publicKey:
    process.env.REACT_APP_STRIPE_PUBLIC_KEY ??
    "pk_live_51NhzD0CuhRE3tfoWUPvCw1vmuKykU02bbb3xRldcUCOJgsVe6epzlmGMwPH6EjPZmidtSbIzmfG8xQvU9dLVpAEx00XmmbEvcS",
};

export default stripeConfig;
